export const initSearch = () => {
    var searchIcon = document.getElementsByClassName('site-header__content__search');
    var closeIcon = document.getElementsByClassName('close-search-bar');
    var input = document.getElementById('search-bar__input');
    var allHeaderContainer = document.getElementsByClassName('site-header__content-container');
    var allSearchBars = document.getElementsByClassName('search-bar');

    for (var i = 0; i < searchIcon.length; i++) {
        (function (index) {

            searchIcon[index].addEventListener('click', function () {
                for (var x = 0; x < allHeaderContainer.length; x++) {
                    allHeaderContainer[x].classList.add('header-bar--is-closed');
                } for (var x = 0; x < allSearchBars.length; x++) {
                    allSearchBars[x].classList.add('search-bar--is-open');
                }
                input.focus();
            })
        })(i);
    }

    for (var i = 0; i < closeIcon.length; i++) {
        (function (index) {
            closeIcon[index].addEventListener('click', function () {
                for (var x = 0; x < allHeaderContainer.length; x++) {
                    allHeaderContainer[x].classList.remove('header-bar--is-closed');
                } for (var x = 0; x < allSearchBars.length; x++) {
                    allSearchBars[x].classList.remove('search-bar--is-open');
                }
            })
        })(i);
    }
};